<script lang="ts" generics="T extends string">
  import { popup, type PopupSettings } from '@skeletonlabs/skeleton'

  import Icon from '$lib/components/Icon.svelte'

  interface Props {
    invalids: Record<T, { invalid: boolean; reason: string }>
    field: T
    value?: string | null
  }

  const { invalids, field, value }: Props = $props()

  const getInvalidHover: (field: keyof typeof invalids) => PopupSettings = (field) => ({
    event: 'hover',
    placement: 'bottom',
    target: `invalid${field}Hover`,
  })
</script>

{#if invalids[field]?.invalid}
  <div class="input-group-shim" use:popup={getInvalidHover(field)}>
    <span>
      <Icon icon="iconoir:warning-circle" class="pointer-events-none text-error-600" />
    </span>
  </div>
{:else}
  <div class="input-group-shim">
    <span>
      {#if !!value && value !== ''}
        <Icon icon="iconoir:check-circle" class="text-success-400" />
      {:else}
        <Icon icon="iconoir:check-circle" class="text-surface-400" />
      {/if}
    </span>
  </div>
{/if}
